import { Button } from "@/components/ui/button";
import { Clock, MapPin } from "lucide-react";
import { useActivePromotions } from "@/hooks/usePromotions";

interface Service {
  id: string;
  name: string;
  duration_minutes: number;
  description: string;
  price: number;
}

interface ServiceWithPromotionProps {
  service: Service;
  providerName: string;
  selectedDate: string;
  onSelect: (serviceId: string) => void;
}

const ServiceWithPromotion = ({ service, providerName, selectedDate, onSelect }: ServiceWithPromotionProps) => {
  console.log('ServiceWithPromotion rendering for service:', service.id);
  
  const { data: promotions, isLoading, error } = useActivePromotions(service.id);
  
  console.log('ServiceWithPromotion promotions data:', promotions, 'loading:', isLoading, 'error:', error);
  
  const promotion = promotions && promotions.length > 0 ? promotions[0] : undefined;

  const originalPrice = service.price;
  const discountedPrice = promotion 
    ? (promotion.discount_type === 'percentage' 
        ? originalPrice * (1 - promotion.discount_percentage! / 100)
        : Math.max(0, originalPrice - promotion.discount_amount!))
    : originalPrice;

  const hasPromotion = !!promotion;

  return (
    <div className="border border-gray-200 rounded-lg p-3 sm:p-4 hover:bg-gray-50 transition-colors">
      <div className="flex flex-col sm:flex-row items-start justify-between space-y-3 sm:space-y-0">
        <div className="flex-1 w-full">
          <h3 className="font-semibold text-base sm:text-lg">{service.name}</h3>
          <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-1 sm:space-y-0 sm:space-x-4 text-sm text-gray-600 mt-1">
            <div className="flex items-center space-x-1">
              <Clock className="h-4 w-4" />
              <span>{service.duration_minutes} min</span>
            </div>
            <div className="flex items-center space-x-1">
              <MapPin className="h-4 w-4" />
              <span>{providerName}</span>
            </div>
          </div>
          <p className="text-gray-600 text-sm mt-2">{service.description}</p>
          {hasPromotion && (
            <div className="mt-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-md inline-block">
              Promotion - {promotion?.name}
            </div>
          )}
        </div>
        <div className="flex flex-row sm:flex-col lg:flex-row items-center justify-between sm:justify-end w-full sm:w-auto space-x-4 sm:space-x-0 lg:space-x-4">
          <div className="text-right">
            {hasPromotion ? (
              <div>
                <span className="text-sm text-gray-500 line-through">£{originalPrice.toFixed(2)}</span>
                <span className="text-lg sm:text-xl font-semibold text-green-600 ml-2">£{discountedPrice.toFixed(2)}</span>
              </div>
            ) : (
              <span className="text-lg sm:text-xl font-semibold">£{originalPrice.toFixed(2)}</span>
            )}
          </div>
          <Button 
            variant="outline" 
            className="text-sm px-6 py-2 rounded-full border-2 bg-white hover:bg-gray-50" 
            onClick={() => onSelect(service.id)}
          >
            Book
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceWithPromotion;